export default "https://kr-a.kakaopagecdn.com/web/qa/5.5.0-rc.0/static/v4/event/icon-quiz-a-fa2b10bca7be91839f22ec78b5364c0e.svg";